import { Plus, Trash2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { cn } from '@/lib/utils'

export const EVERYONE_ELSE_VALUE = '__everyone_else__'
export const EVERYONE_ELSE_LABEL = 'Everyone else'
export const GROUP_LABEL_WRAP_CLASS = 'min-w-0 whitespace-normal break-words [overflow-wrap:anywhere]'
export const GROUP_SELECT_TRIGGER_CLASS = 'min-h-8 !h-auto w-full items-start whitespace-normal py-1.5 pr-8 text-left leading-snug [&_[data-slot=select-value]]:!line-clamp-none [&_[data-slot=select-value]]:block [&_[data-slot=select-value]]:min-w-0 [&_[data-slot=select-value]]:whitespace-normal [&_[data-slot=select-value]]:break-words [&_[data-slot=select-value]]:[overflow-wrap:anywhere]'
export const GROUP_SELECT_ITEM_CLASS = 'items-start whitespace-normal break-words leading-snug [overflow-wrap:anywhere] *:[span]:last:min-w-0 *:[span]:last:whitespace-normal *:[span]:last:break-words *:[span]:last:[overflow-wrap:anywhere]'

export const normalizeLabel = (value) => String(value || '').trim().toLowerCase()

export function GroupQuickAddButton({ label, count, onClick }) {
  const text = count !== undefined ? `${label} (${count})` : label
  return (
    <Button
      type="button"
      variant="outline"
      size="sm"
      className="h-auto min-h-7 min-w-0 max-w-full shrink justify-start whitespace-normal px-2 py-1 text-left leading-snug"
      onClick={onClick}
    >
      <Plus className="mr-1 h-3.5 w-3.5 shrink-0" />
      <span className={GROUP_LABEL_WRAP_CLASS}>{text}</span>
    </Button>
  )
}

export function GroupRowHeader({ ariaLabel, value, options, onValueChange, employeeCount, removeLabel, onRemove }) {
  return (
    <div className="space-y-1">
      <div className="flex items-center justify-between gap-2">
        <Label className="text-xs text-muted-foreground">Group</Label>
        <div className="flex items-center gap-1">
          <span
            className={cn('rounded-full px-2 py-0.5 text-xs font-medium', employeeCount > 0 ? 'bg-muted text-muted-foreground' : 'bg-amber-100 text-amber-800')}
            title={employeeCount > 0 ? undefined : 'No employees in the employee list match this group'}
          >
            {employeeCount} {employeeCount === 1 ? 'employee' : 'employees'}
          </span>
          <Button type="button" variant="ghost" size="sm" className="h-7 w-7 shrink-0 p-0 text-muted-foreground hover:text-destructive" aria-label={removeLabel} onClick={onRemove}>
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </div>
      <Select value={value} onValueChange={onValueChange}>
        <SelectTrigger aria-label={ariaLabel} className={GROUP_SELECT_TRIGGER_CLASS}><SelectValue /></SelectTrigger>
        <SelectContent>
          {options.map((option) => (
            <SelectItem key={option.value} value={option.value} className={GROUP_SELECT_ITEM_CLASS}>{option.label}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
